/**
 * ВЕРХ ВИТРИНЫ КВАРТИР ОДНОГО ЖК — галерея дома, пульт и ЧЕСТНЫЕ ЧИСЛА ДОМА.
 * Пара к /css/jk-flats-hero.css. Префикс всех классов — zvh-.
 * Работает ТОЛЬКО на /novostroyki/<город>/zhk-<slug>/kvartiry/ — там, где
 * сервер напечатал `window.BRONI_FLATS_BUILDING_ID`.
 *
 * ЧТО ВИДИТ ЧЕЛОВЕК
 *   1. Под заголовком — большой кадр дома, под ним лента квадратиков и стрелки;
 *      клик по кадру открывает его во весь экран.
 *   2. Рядом — пульт: сколько квартир в ЭТОМ доме, полоса «сдано / строится» и
 *      столбики по комнатности; клик по столбику отбирает эту комнатность.
 *   3. Ниже — одна строка описания и ссылка на карточку ЖК.
 *
 * ⛔ ГЛАВНОЕ: ЧИСЛА В ШАПКЕ БЫЛИ ГОРОДСКИЕ, А СТРАНИЦА — ПРО ОДИН ДОМ.
 *    flats.js зовёт `flat_api.php?action=stats&city=<город>` и пишет городские
 *    итоги в #statFlats / #statBuildings / #statPriceFrom / #flatsHeroSub.
 *    Замер прода 21.08 на /novostroyki/krasnodar/zhk-dogma-park/kvartiry/:
 *    #statFlats = 14 682 и #statBuildings = 16 при 1 803 квартирах в самом доме.
 *
 * ⛔ ПОЧЕМУ НЕ ПЕРЕЗАПИСЫВАЕМ ЧУЖИЕ УЗЛЫ. flats.js пишет в них АСИНХРОННО и при
 *    каждой перезагрузке статистики. Перезапись «один раз при загрузке»
 *    затирается его ответом — вид получается «иногда верный», самый дорогой вид
 *    поломки. Поэтому узлы НЕ трогаем по содержимому и НЕ удаляем (удаление
 *    уронило бы чужой скрипт), а прячем стилем по классу `zvh-jk`; свои числа
 *    держим в СВОИХ узлах, в которые не пишет никто. Гонка исчезает не победой
 *    в ней, а тем, что участников больше нет.
 *
 * ОТКУДА ЧИСЛА (только настоящие источники сайта, ничего не пересчитываем):
 *   · flat_api.php?action=jk_facets&building_id=N — тот же ответ, которым живёт
 *     фильтр в карточке ЖК: total, price.min/max, area.min/max, rooms[],
 *     deadlines[]. Считается тем же `buildListWhere`, что и сама выдача, —
 *     поэтому наше главное число совпадает с «Показать N квартир» (#flatsCount)
 *     до единицы.
 *   · map_api.php?action=markers&city=… — координаты дома (9 КБ).
 *   · map_api.php?action=list&city=…&bbox=<коробка вокруг дома> — photos[],
 *     building_class, url. Коробка нужна, чтобы не тянуть 82 КБ на 50 ЖК ради
 *     одного: с bbox ответ ~6 КБ и в нём ровно наш дом. Формат bbox =
 *     minLat,minLng,maxLat,maxLng (MapHandler::buildFilterWhere).
 *
 * ⛔ ЧЕГО НЕТ — ТОГО НЕ ПОКАЗЫВАЕМ. Каждая часть рисуется, только если её
 *    величина реально приехала. Пустая рамка на месте фото хуже отсутствия блока.
 *
 * ⛔ ЧУЖИЕ КАРТИНКИ — ЧЕРЕЗ /img-thumb.php: домены застройщиков отдают исходники
 *    по несколько мегабайт, а уменьшитель отдаёт webp со своего домена (потолок
 *    ширины у него 1200 px, больше просить бессмысленно).
 */
(() => {
  'use strict';

  // Второй запуск на той же странице (зеркало приёмки подмешивает файл поверх
  // уже подключённого) собрал бы блок дважды.
  if (window.__broniJkFlatsHero) return;

  const bid = parseInt(window.BRONI_FLATS_BUILDING_ID, 10);
  if (!bid || bid <= 0) return;        // городская витрина — там числа верные

  const hero = document.querySelector('.page-hero--flats .container')
            || document.querySelector('.page-hero .container');
  if (!hero) return;
  if (hero.querySelector('.zvh')) return;

  window.__broniJkFlatsHero = true;

  const html = document.documentElement;
  const title = hero.querySelector('.page-hero-title');
  // ⛔ 24.09.2026: ГЕНПЛАН ВМЕСТО РЕНДЕРОВ. Слово владельца: «переделать витрину, где
  // вместо рендеров будет генплан с корпусами, как на странице ЖК». Сервер печатает
  // компактный генплан (components/jk-genplan.php) под заголовком ТОЛЬКО у дома со
  // схемой, где обведены корпуса; тогда галерея не собирается, а генплан встаёт на её
  // место рядом с пультом чисел. Нет генплана — всё как было: кадры дома.
  const plan = hero.querySelector('[data-genplan]');

  /**
   * ⛔ ОСЬ КАРТЫ — НЕ ГОРОД ИЗ БАЗЫ, И НА 28 ДОМАХ ЭТО РАЗНЫЕ ВЕЩИ.
   * У ВСЕХ подмосковных домов `b.city = 'moscow'`, а витрины и карта разведены
   * осью `region_group` (ADR-078). Сервер печатает в `BRONI_FLATS_CITY` именно
   * городской столбец, поэтому черновик спрашивал у карты `city=moscow` — и не
   * находил там подмосковный дом ВООБЩЕ. Замер 21.08: `markers&city=moscow`
   * отдаёт 88 меток и дома 11 («Публицист», Пушкино) среди них нет;
   * `markers&city=podmoskovye` — 27 меток, дом на месте с координатами и фото.
   * Виден дефект только числом: блок собирался, числа были верные, а галереи не
   * было ни на одном из 28 домов Подмосковья — и выглядело это как «у этих ЖК
   * просто нет фотографий».
   *
   * Ось стоит первым сегментом ЧПУ-адреса (`/novostroyki/podmoskovye/…`). На
   * старом адресе `/flats.php?building_id=N` сегмента нет — там откатываемся на
   * серверную переменную, и это по-прежнему верно: такой адрес бывает только у
   * домов, чья ось совпадает с городом.
   */
  const routeAxis = (location.pathname.match(/^\/novostroyki\/([a-z0-9-]+)\//) || [])[1] || '';
  const dbCity = String(window.BRONI_FLATS_CITY || '');
  const city = routeAxis || dbCity;

  // ⛔ МЕТКА СТАВИТСЯ СРАЗУ, ДО ЕДИНОГО ЗАПРОСА. По ней стиль (а) гасит городские
  // числа — они неверные, и показать их на секунду значит дать прочитать ложь;
  // (б) маскирует четыре секции ниже шапки, чтобы вставка блока не двигала
  // страницу на глазах. Снимает маску `finish()` — или аварийный таймер в CSS,
  // если мы умрём молча.
  html.classList.add('zvh-jk');

  let finished = false;
  const finish = (ok) => {
    if (finished) return;
    finished = true;
    html.classList.add(ok ? 'zvh-ready' : 'zvh-broken');
  };

  // ── мелочи ──────────────────────────────────────────────────────────────
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };

  const num = (n) => new Intl.NumberFormat('ru-RU').format(n);

  // Формат цены — ровно как у сайтового flats.js (fmtPrice), чтобы «от 2,8 млн ₽»
  // в нашем блоке и в карточках квартир читались одинаково.
  const price = (p) => {
    if (!p) return null;
    if (p >= 1000000) {
      return String((p / 1000000).toFixed(1)).replace(/\.0$/, '').replace('.', ',') + ' млн ₽';
    }
    return num(p) + ' ₽';
  };

  const area = (a) => {
    const n = parseFloat(a);
    if (!isFinite(n)) return null;
    return (n % 1 === 0 ? n.toFixed(0) : n.toFixed(1)).replace('.', ',');
  };

  const plural = (n, one, few, many) => {
    const m10 = n % 10;
    const m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return one;
    if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return few;
    return many;
  };

  const thumb = (url, w) => {
    if (!url) return null;
    if (url.charAt(0) === '/') return url;            // своё — уже локальное
    if (!/^https?:\/\//i.test(url)) return null;
    return '/img-thumb.php?src=' + encodeURIComponent(url) + '&w=' + w;
  };

  const getJson = (url) => fetch(url, { credentials: 'same-origin' })
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null);

  // ── КРУПНЫЙ ПРОСМОТР ────────────────────────────────────────────────────
  // Один узел на страницу, картинка подставляется по клику.
  let lb = null;
  let lbImg = null;
  let lbList = [];
  let lbIdx = 0;

  const lbShow = (i) => {
    if (!lbList.length) return;
    lbIdx = (i + lbList.length) % lbList.length;
    lbImg.src = lbList[lbIdx];
  };

  function lbKey(e) {
    if (e.key === 'Escape') lbClose();
    else if (e.key === 'ArrowRight') lbShow(lbIdx + 1);
    else if (e.key === 'ArrowLeft') lbShow(lbIdx - 1);
  }

  function lbClose() {
    if (lb) lb.classList.remove('zvh-lb--open');
    document.removeEventListener('keydown', lbKey);
  }

  const lbBuild = () => {
    lb = el('div', 'zvh-lb');
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Фотографии жилого комплекса');

    lbImg = el('img', 'zvh-lb-img');
    lbImg.alt = '';

    const close = el('button', 'zvh-lb-close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Закрыть');
    close.appendChild(el('i', 'fa-solid fa-xmark'));

    const prev = el('button', 'zvh-lb-nav zvh-lb-nav--prev');
    prev.type = 'button';
    prev.setAttribute('aria-label', 'Предыдущее фото');
    prev.appendChild(el('i', 'fa-solid fa-chevron-left'));

    const next = el('button', 'zvh-lb-nav zvh-lb-nav--next');
    next.type = 'button';
    next.setAttribute('aria-label', 'Следующее фото');
    next.appendChild(el('i', 'fa-solid fa-chevron-right'));

    close.addEventListener('click', lbClose);
    prev.addEventListener('click', (e) => { e.stopPropagation(); lbShow(lbIdx - 1); });
    next.addEventListener('click', (e) => { e.stopPropagation(); lbShow(lbIdx + 1); });
    lb.addEventListener('click', (e) => { if (e.target === lb || e.target === lbImg) lbClose(); });

    lb.appendChild(lbImg);
    lb.appendChild(close);
    lb.appendChild(prev);
    lb.appendChild(next);
    document.body.appendChild(lb);
  };

  const lbOpen = (list, i) => {
    if (!list.length) return;
    lbList = list;
    if (!lb) lbBuild();
    lb.classList.add('zvh-lb--open');
    document.addEventListener('keydown', lbKey);
    lbShow(i);
  };

  // ── ГАЛЕРЕЯ ─────────────────────────────────────────────────────────────
  /**
   * ⛔ ЖИВЫЕ КАДРЫ — ОДИН СПИСОК, И УЗЕЛ КВАДРАТИКА ЛЕЖИТ В НЁМ ЖЕ. В черновике
   * список кадров и дети ленты нумеровались независимо: битый квадратик убирал
   * себя из DOM, но оставался в списке, и `thumbs.children[cur]` после первой же
   * ошибки указывал на ЧУЖОЙ кадр — подсветка съезжала, а «удаление битого»
   * убирало исправный. Теперь удаление всегда идёт парой: запись из списка и её
   * собственный узел.
   */
  const buildGallery = (photos, jkName) => {
    if (!photos.length) return null;

    const gal = el('div', 'zvh-gal');
    const stage = el('div', 'zvh-stage');
    const big = el('button', 'zvh-big');
    big.type = 'button';
    big.setAttribute('aria-label', 'Открыть фото крупно');
    const bigImg = el('img', 'zvh-big-img');
    bigImg.decoding = 'async';
    big.appendChild(bigImg);

    const prev = el('button', 'zvh-arr zvh-arr--prev');
    const next = el('button', 'zvh-arr zvh-arr--next');
    prev.type = 'button';
    next.type = 'button';
    prev.setAttribute('aria-label', 'Предыдущее фото');
    next.setAttribute('aria-label', 'Следующее фото');
    prev.appendChild(el('i', 'fa-solid fa-chevron-left'));
    next.appendChild(el('i', 'fa-solid fa-chevron-right'));

    const counter = el('span', 'zvh-count');
    const thumbs = el('div', 'zvh-thumbs');

    const live = [];
    let cur = 0;

    const show = (i) => {
      if (!live.length) return;
      cur = (i + live.length) % live.length;
      bigImg.src = live[cur].big;
      bigImg.alt = jkName ? (jkName + ' — фото ' + (cur + 1)) : '';
      counter.textContent = (cur + 1) + ' / ' + live.length;
      live.forEach((entry, k) => {
        entry.node.classList.toggle('zvh-th--on', k === cur);
      });
      // ⛔ Двигаем ТОЛЬКО ленту, руками. `scrollIntoView` прокручивает всех
      // предков разом и на телефоне уводил бы саму страницу.
      const act = live[cur].node;
      const left = act.offsetLeft;
      const right = left + act.offsetWidth;
      if (left < thumbs.scrollLeft) thumbs.scrollLeft = left;
      else if (right > thumbs.scrollLeft + thumbs.clientWidth) {
        thumbs.scrollLeft = right - thumbs.clientWidth;
      }
    };

    const drop = (entry) => {
      const k = live.indexOf(entry);
      if (k < 0) return;
      live.splice(k, 1);
      entry.node.remove();
      if (!live.length) { gal.remove(); return; }
      if (live.length === 1) {
        prev.remove();
        next.remove();
        counter.remove();
        thumbs.remove();
      }
      show(cur >= live.length ? 0 : cur);
    };

    photos.forEach((src, i) => {
      const small = thumb(src, 200);
      const mid = thumb(src, 900);
      const full = thumb(src, 1200);
      if (!small) return;

      const th = el('button', 'zvh-th');
      th.type = 'button';
      th.setAttribute('aria-label', 'Фото ' + (i + 1));
      const ti = el('img', 'zvh-th-img');
      ti.src = small;
      ti.loading = i < 6 ? 'eager' : 'lazy';
      ti.decoding = 'async';
      ti.alt = '';
      th.appendChild(ti);

      const entry = { big: mid || small, full: full || mid || small, node: th };
      live.push(entry);

      ti.addEventListener('error', () => drop(entry));
      th.addEventListener('click', () => {
        const k = live.indexOf(entry);
        if (k >= 0) show(k);
      });
      thumbs.appendChild(th);
    });

    if (!live.length) return null;

    prev.addEventListener('click', (e) => { e.stopPropagation(); show(cur - 1); });
    next.addEventListener('click', (e) => { e.stopPropagation(); show(cur + 1); });
    big.addEventListener('click', () => lbOpen(live.map((x) => x.full), cur));
    // Большой кадр не загрузился — уводим его из списка и показываем следующий,
    // а не оставляем дыру на самом видном месте.
    bigImg.addEventListener('error', () => { if (live[cur]) drop(live[cur]); });

    stage.appendChild(big);
    // Стрелки и счётчик нужны, только когда есть что листать.
    if (live.length > 1) {
      stage.appendChild(prev);
      stage.appendChild(next);
      stage.appendChild(counter);
    }
    gal.appendChild(stage);
    if (live.length > 1) gal.appendChild(thumbs);
    show(0);
    return gal;
  };

  // ── ПОЛОСА «СДАНО / СТРОИТСЯ» ───────────────────────────────────────────
  /**
   * ⛔ ЦВЕТ БЕРЁТСЯ ИЗ ПОЛЯ `state`, А НЕ ИЗ МЕСТА В СПИСКЕ. Черновик красил
   * золотом («сдан») первый элемент deadlines[]. У «Тёплых краёв» сданный
   * корпус и правда идёт первым, и на нём это выглядело правильно. У DОГМА ПАРК
   * порядок другой: первым приходит «Строится · 2 кв. 2026», а «Сдан 2024»
   * четвёртым — черновик обещал бы сданными 75 строящихся квартир. Приёмка «по
   * одному дому» тут была монеткой; сервер состояние отдаёт, надо его читать.
   *
   * Доли считаются от суммы самих count, а не от total: разойдись они (лот без
   * срока), полоса не должна врать про остаток. Одно состояние — полосы нет:
   * сплошная заливка «100 %» не сообщает ничего.
   */
  const buildScale = (deadlines) => {
    if (!Array.isArray(deadlines)) return null;
    const parts = deadlines
      .map((d) => ({
        label: String(d.label || '').replace(/^Строится\s*·\s*/, '').trim(),
        count: Number(d.count),
        done: String(d.state || '') === 'done',
      }))
      .filter((d) => d.label && Number.isFinite(d.count) && d.count > 0);
    if (parts.length < 2) return null;

    // Сданное — слева: полоса читается как «сколько пути пройдено».
    parts.sort((a, b) => (a.done === b.done ? 0 : (a.done ? -1 : 1)));

    const sum = parts.reduce((a, d) => a + d.count, 0);
    if (!sum) return null;

    const bar = el('div', 'zvh-scale');
    const line = el('div', 'zvh-scale-line');
    parts.forEach((d) => {
      const seg = el('span', 'zvh-scale-seg' + (d.done ? ' zvh-scale-seg--done' : ''));
      seg.style.width = (d.count / sum * 100).toFixed(2) + '%';
      seg.title = d.label + ' — ' + num(d.count);
      line.appendChild(seg);
    });
    bar.appendChild(line);

    const legend = el('div', 'zvh-scale-keys');
    parts.forEach((d) => {
      const k = el('span', 'zvh-scale-key' + (d.done ? ' zvh-scale-key--done' : ''));
      k.appendChild(el('i', 'zvh-scale-dot'));
      k.appendChild(el('span', null, d.label + ' — ' + num(d.count)));
      legend.appendChild(k);
    });
    bar.appendChild(legend);
    return bar;
  };

  // ── СТОЛБИКИ ПО КОМНАТНОСТИ ─────────────────────────────────────────────
  /**
   * ⛔ ВСЁ ОТ ЧЕТЫРЁХ КОМНАТ СВОДИТСЯ В ОДИН СТОЛБИК «4к+», ПОТОМУ ЧТО ИМЕННО
   * ТАК СЧИТАЕТ ФИЛЬТР. В ряду #roomsBtns последняя кнопка — «4к+» (rooms_min),
   * отдельных «5к» и «6к» там нет. Черновик рисовал столбик на каждое значение
   * из facets: у ЖК VEER выходили «4к — 2» и «5к — 1», причём клик по «5к» не
   * делал НИЧЕГО (кнопки нет), а клик по «4к» открывал 3 квартиры при подписи
   * «2». Два списка с одним смыслом разошлись бы на первом же доме с
   * пятикомнатными — а он уже есть в проде.
   *
   * ⛔ Клик ходит ЧЕРЕЗ ШТАТНУЮ КНОПКУ фильтра, а не в обход: свой запрос к
   * серверу был бы вторым источником одной выдачи, и подсветка фильтра
   * разошлась бы с тем, что на экране.
   */
  const ROOMS_LAST_BTN = 4;

  const buildChart = (rooms) => {
    if (!Array.isArray(rooms)) return null;

    const bucket = new Map();
    rooms.forEach((x) => {
      const value = Number(x.value);
      const count = Number(x.count);
      if (!Number.isFinite(value) || value < 0) return;
      if (!Number.isFinite(count) || count <= 0) return;
      const key = Math.min(value, ROOMS_LAST_BTN);
      const label = key === ROOMS_LAST_BTN
        ? '4к+'
        : String(x.label || '').trim().replace(/-комн$/, 'к');
      if (!label) return;
      const prev = bucket.get(key);
      if (prev) prev.count += count;
      else bucket.set(key, { key: key, label: label, count: count });
    });

    const list = Array.from(bucket.values()).sort((a, b) => a.key - b.key);
    if (list.length < 2) return null;

    const max = list.reduce((a, x) => Math.max(a, x.count), 0);
    const sum = list.reduce((a, x) => a + x.count, 0);

    const chart = el('div', 'zvh-chart');
    chart.appendChild(el('div', 'zvh-chart-cap', 'Что есть в продаже'));
    const bars = el('div', 'zvh-bars');

    list.forEach((x, i) => {
      const share = sum ? Math.round(x.count / sum * 100) : 0;
      const col = el('button', 'zvh-bar');
      col.type = 'button';
      col.style.setProperty('--zvh-i', String(i));
      col.setAttribute('aria-label', x.label + ' — ' + num(x.count) + ' ('
        + share + '% предложения)');

      const stem = el('span', 'zvh-bar-stem');
      const fill = el('span', 'zvh-bar-fill');
      // Высота — от САМОГО КРУПНОГО столбика, а не от суммы: доли по 13 % и 9 %
      // на общей шкале выглядели бы одинаковыми обрубками.
      fill.style.height = Math.max(6, Math.round(x.count / max * 100)) + '%';
      stem.appendChild(fill);

      col.appendChild(el('span', 'zvh-bar-num', num(x.count)));
      col.appendChild(stem);
      col.appendChild(el('span', 'zvh-bar-lbl', x.label));

      col.addEventListener('click', () => {
        const btn = document.querySelector(
          '#roomsBtns .room-btn[data-rooms="' + String(x.key) + '"]');
        if (btn) btn.click();
      });
      bars.appendChild(col);
    });

    chart.appendChild(bars);
    return chart;
  };

  // ── СБОРКА ──────────────────────────────────────────────────────────────
  const build = (facts, photos, extra) => {
    const total = facts && typeof facts.total === 'number' ? facts.total : null;
    const pMin = facts && facts.price ? facts.price.min : null;
    const pMax = facts && facts.price ? facts.price.max : null;
    const aMin = facts && facts.area ? facts.area.min : null;
    const aMax = facts && facts.area ? facts.area.max : null;
    const jkName = (facts && facts.building && facts.building.name) || null;
    const klass = extra.building_class || null;
    const jkUrl = extra.url || null;

    // Ни одного честного числа и ни одного кадра — блока нет вовсе. Рисовать «—»
    // на месте цифры значит показать пустую рамку: это хуже, чем ничего.
    if (total === null && !photos.length && !plan) return false;

    const box = el('div', plan ? 'zvh zvh--genplan' : 'zvh');

    // Генплан уже в разметке — переносим узел целиком (обработчики jk-genplan.js
    // едут вместе с ним), кадры дома не собираем вовсе.
    const gal = plan ? null : buildGallery(photos, jkName);
    if (plan) box.appendChild(plan);
    else if (gal) box.appendChild(gal);

    // ── пульт ──
    const pult = el('div', 'zvh-pult');
    const capRow = el('div', 'zvh-pult-top');
    if (total !== null) {
      const cap = el('div', 'zvh-cap');
      cap.appendChild(el('span', 'zvh-cap-val', num(total)));
      cap.appendChild(el('span', 'zvh-cap-lbl',
        plural(total, 'квартира в продаже', 'квартиры в продаже', 'квартир в продаже')));
      capRow.appendChild(cap);
    }
    // ⛔ ЗАСТРОЙЩИКА В ПУЛЬТЕ НЕТ (владелец 20.08: «СК «Семья» это убери»).
    // Имя застройщика остаётся на карточке ЖК, куда ведёт ссылка «Всё о жилом
    // комплексе»; здесь оно занимало место рядом с числом квартир, ничего не
    // сообщая о самом предложении.
    if (klass) {
      const meta = el('div', 'zvh-cap-meta');
      meta.appendChild(el('span', 'zvh-tag', klass));
      capRow.appendChild(meta);
    }
    if (capRow.children.length) pult.appendChild(capRow);

    const scale = buildScale(facts && facts.deadlines);
    if (scale) pult.appendChild(scale);

    const chart = buildChart(facts && facts.rooms);
    if (chart) pult.appendChild(chart);

    // ⛔ 25.09.2026, слово владельца: «справа то, что сколько квартир осталось, можешь
    // убрать; сделай генплан на всю ширину». При генплане пульта нет: число квартир и
    // вилка цен остаются строкой описания ниже и итогом «Найдено N» выдачи, столбики
    // комнатности дублировали чипы «Студия · 1к · 2к» фильтра (они и переключали их),
    // сроки сдачи по-прежнему выбираются фильтром «Сдача» в «Ещё фильтры».
    if (pult.children.length && !plan) box.appendChild(pult);
    if (!box.children.length) return false;

    // ── описание — НИЖЕ ленты (просьба владельца) ──
    // Собирается ровно из тех же приехавших величин; чего нет — того нет в
    // тексте. Голова фразы отделяется тире, хвосты — запятыми: два тире подряд
    // читаются как обрывки, а не как предложение.
    const tailParts = [];
    let head = null;
    if (total !== null) {
      head = num(total) + ' ' + plural(total, 'квартира', 'квартиры', 'квартир')
           + (jkName ? ' в ' + jkName : '');
    }
    if (pMin && pMax) tailParts.push('от ' + price(pMin) + ' до ' + price(pMax));
    else if (pMin) tailParts.push('от ' + price(pMin));
    if (aMin && aMax) tailParts.push('площадь от ' + area(aMin) + ' до ' + area(aMax) + ' м²');

    const phrase = head
      ? (tailParts.length ? head + ' — ' + tailParts.join(', ') : head)
      : tailParts.join(', ');
    const desc = phrase ? el('p', 'zvh-desc', phrase + '.') : null;

    let more = null;
    if (jkUrl && /^\/[^/]/.test(jkUrl)) {
      more = el('a', 'zvh-more');
      more.href = jkUrl;
      more.appendChild(el('span', null, 'Всё о жилом комплексе'));
      more.appendChild(el('i', 'fa-solid fa-arrow-right'));
    }

    // ── вставка: сразу под H1, описание ниже ──
    // ⛔ КРОШКИ СТОЯТ ВЫШЕ H1 И НЕ ТРОГАЮТСЯ. Их собирает сервер
    // (JkCardBreadcrumbs), тот же массив уходит в BreadcrumbList; вставка идёт
    // ПОСЛЕ заголовка, поэтому цепочка остаётся первым узлом шапки.
    const anchor = title || hero.firstElementChild;
    if (!anchor) return false;
    // Генплан сервер печатает сразу под заголовком — блок встаёт ровно на его место,
    // и схема при переносе в сетку не прыгает по странице.
    anchor.insertAdjacentElement('afterend', box);
    let tail = box;
    if (desc) { tail.insertAdjacentElement('afterend', desc); tail = desc; }
    if (more) { tail.insertAdjacentElement('afterend', more); }

    return true;
  };

  // ── ЗАГРУЗКА ────────────────────────────────────────────────────────────
  const facetsUrl = '/flat_api.php?action=jk_facets&building_id=' + bid;

  /**
   * ⛔ ОДИН ЗАПРОС ФАСЕТОВ ДОМА НА СТРАНИЦУ (27.09.2026). Тот же адрес спрашивает блок вкладки
   * «Планировки» витрины (js/jk-filter.js, `sharedFacets`): кто первый — тот и
   * спрашивает, второй берёт то же обещание из `window.BRONI_JK_FACETS[адрес]`. Форма
   * `{ok, status, data}` — одна в обоих файлах; для шапки она сводится к прежнему `getJson`:
   * данные ответа 2xx, иначе null.
   */
  const facetsOnce = (url) => {
    const box = window.BRONI_JK_FACETS || (window.BRONI_JK_FACETS = {});
    if (!box[url]) {
      box[url] = fetch(url, { credentials: 'same-origin' }).then((r) => (r.ok
        ? r.json().then((data) => ({ ok: true, status: r.status, data: data }))
        : { ok: false, status: r.status, data: null }));
    }
    return box[url].then((res) => (res && res.ok ? res.data : null)).catch(() => null);
  };

  /**
   * ⛔ ЗАПРОСЫ УХОДЯТ СРАЗУ, А РАЗМЕТКА ПРАВИТСЯ ТОЛЬКО ПОСЛЕ DOMContentLoaded —
   * И ЭТО НЕ ОСТОРОЖНОСТЬ, А ЗАМЕР. Соседний блок витрины (flats-showcase.js)
   * перестраивает фильтр в одну строку на DOMContentLoaded. Наши три ответа
   * успевали прийти РАНЬШЕ: мы вставляли галерею, снимали маскировку — и через
   * 70 мс сосед сжимал фильтр, уже на глазах у человека. Замер 405×928,
   * timeline по 10 мс: `zvh-ready` в 602 мс (низ выдачи на 1674 px), `zkv-ready`
   * в 672 мс (низ выдачи прыгает на 866 px), CLS 0,232 против 0,148 без блока —
   * то есть маскировка не помогала, а мешала.
   *
   * ⛔ ЖДЁМ СОБЫТИЕ, А НЕ СВЕРЯЕМ readyState С 'loading'. Файл подключён с defer:
   * во время его исполнения readyState уже 'interactive', и привычная проверка
   * пропустила бы нас вперёд соседа — ровно в ту же дыру. Мгновенный путь
   * оставлен только для 'complete' (скрипт подмешали в готовую страницу — так
   * делает зеркало приёмки).
   */
  const domReady = document.readyState === 'complete'
    ? Promise.resolve()
    : new Promise((res) => {
      document.addEventListener('DOMContentLoaded', () => res(), { once: true });
    });

  /** Метка дома на оси карты; null — оси такой нет или дома на ней нет. */
  const findMarker = (axis) => {
    if (!axis) return Promise.resolve(null);
    return getJson('/map_api.php?action=markers&city=' + encodeURIComponent(axis))
      .then((res) => {
        if (!res || !res.ok || !Array.isArray(res.markers)) return null;
        const mk = res.markers.find((m) => Number(m.id) === bid) || null;
        return mk ? { mk: mk, axis: axis } : null;
      });
  };

  // Ось из адреса — основная; серверный город остаётся страховкой на случай
  // адреса без ЧПУ-сегмента и на случай, если ось из адреса когда-нибудь
  // разойдётся с осью карты. Второй запрос уходит ТОЛЬКО когда первый не нашёл
  // дом (на замере 21.08 — ни разу).
  const markerHunt = findMarker(city).then(
    (found) => (found || (dbCity && dbCity !== city ? findMarker(dbCity) : null)),
  );

  const readPhotos = (item) => {
    if (!item || !item.photos) return [];
    try {
      // ⛔ Поле приходит СТРОКОЙ с JSON внутри — не массивом.
      const arr = typeof item.photos === 'string' ? JSON.parse(item.photos) : item.photos;
      if (Array.isArray(arr)) return arr.filter((u) => typeof u === 'string' && u);
    } catch (e) {
      return [];
    }
    return [];
  };

  Promise.all([facetsOnce(facetsUrl), markerHunt]).then(([facets, found]) => {
    const ok = facets && facets.ok ? facets : null;
    const mk = found ? found.mk : null;

    // Коробка вокруг дома: ответ сжимается с 82 КБ (50 ЖК) до ~6 КБ (наш один).
    if (!mk || !mk.latitude || !mk.longitude) {
      return domReady.then(() => build(ok, mk && mk.image_url ? [mk.image_url] : [],
        { building_class: null, url: null }));
    }

    const axis = found.axis;
    const lat = parseFloat(mk.latitude);
    const lng = parseFloat(mk.longitude);
    const d = 0.002;
    const bbox = [lat - d, lng - d, lat + d, lng + d].map((v) => v.toFixed(4)).join(',');

    // ⛔ Список спрашиваем ТОЙ ЖЕ осью, что и метки: разойдись они — ответ
    // пришёл бы про другой набор домов, и наш дом в нём просто не нашёлся бы.
    // `fields=card`: нужны `photos`, `image_url`, `building_class` и `url` —
    // галерея и подпись шапки. `photos` в профиле `map` нет.
    return getJson('/map_api.php?action=list&city=' + encodeURIComponent(axis)
      + '&limit=10&fields=card&bbox=' + encodeURIComponent(bbox)).then((list) => {
      let item = null;
      if (list && list.ok && Array.isArray(list.items)) {
        item = list.items.find((it) => Number(it.id) === bid) || null;
      }

      let photos = readPhotos(item);
      if (!photos.length && item && item.image_url) photos = [item.image_url];
      if (!photos.length && mk.image_url) photos = [mk.image_url];

      return domReady.then(() => build(ok, photos, {
        building_class: (item && item.building_class) || null,
        url: (item && item.url) || null,
      }));
    });
  }).then(
    (built) => finish(built === true),
    () => finish(false),
  );
})();
